import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { Button } from './button.js';

const helpers = createMultiStyleConfigHelpers(["root", "trigger", "item", "ellipsis"]);
const Pagination = helpers.defineMultiStyleConfig({
  baseStyle: {
    root: {
      display: "inline-flex",
      gap: "sm"
    },
    trigger: {
      ...Button.baseStyle,
      ...Button.variants?.minimal,
      justifyContent: "center",
      alignItems: "center",
      _disabled: {
        opacity: 0.5
      }
    },
    item: {
      ...Button.baseStyle,
      ...Button.variants?.secondary,
      justifyContent: "center",
      alignItems: "center",
      _hover: {
        bg: "rgba(230, 235, 236, 1)"
      },
      _selected: {
        bg: "rgba(213, 218, 220, 1)",
        _dark: {
          bg: "grayscale.500"
        }
      },
      _disabled: {
        opacity: 0.5
      }
    },
    ellipsis: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  },
  sizes: {
    xs: {
      trigger: {
        ...Button.sizes?.xs,
        width: "xs"
      },
      item: {
        ...Button.sizes?.xs
      },
      ellipsis: {
        ...Button.sizes?.xs
      }
    },
    sm: {
      trigger: {
        ...Button.sizes?.sm,
        width: "sm"
      },
      item: {
        ...Button.sizes?.sm
      },
      ellipsis: {
        ...Button.sizes?.sm
      }
    },
    md: {
      trigger: {
        ...Button.sizes?.md,
        width: "md"
      },
      item: {
        ...Button.sizes?.md
      },
      ellipsis: {
        ...Button.sizes?.md
      }
    },
    lg: {
      trigger: {
        ...Button.sizes?.lg,
        width: "lg"
      },
      item: {
        ...Button.sizes?.lg
      },
      ellipsis: {
        ...Button.sizes?.lg
      }
    }
  }
});

export { Pagination };
